import { z } from 'zod';

export const demoLoginFormSchema = z.object({
    gdpr: z.boolean().refine(val => val === true, { message: 'form.error.required' }),
});

export type DemoLoginFormSchemaType = typeof demoLoginFormSchema;

export type DemoLoginFormValues = z.infer<typeof demoLoginFormSchema>;
